// extracted by mini-css-extract-plugin
module.exports = {"title":"Contact_title__1Qmrt","btn":"Contact_btn__2msCn","text":"Contact_text__2mZEw"};